import { render, staticRenderFns } from "./r-plinko-stage-config-table.vue?vue&type=template&id=0c180e3e"
import script from "./r-plinko-stage-config-table.vue?vue&type=script&lang=js"
export * from "./r-plinko-stage-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c180e3e')) {
      api.createRecord('0c180e3e', component.options)
    } else {
      api.reload('0c180e3e', component.options)
    }
    module.hot.accept("./r-plinko-stage-config-table.vue?vue&type=template&id=0c180e3e", function () {
      api.rerender('0c180e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-stage-config-table.vue"
export default component.exports